import { render } from "./FreeList.vue?vue&type=template&id=b7d4a54c&scoped=true"
import script from "./FreeList.vue?vue&type=script&lang=js"
export * from "./FreeList.vue?vue&type=script&lang=js"

import "./FreeList.vue?vue&type=style&index=0&id=b7d4a54c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d4a54c"]])

export default __exports__